var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIop(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 16,
    cy: 16,
    r: 16,
    fill: "#0CAFA5"
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#FFF"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.413 11.919c-.033-.02-.06-.004-.06.035v2.302a.134.134 0 00.06.105l2.91 1.682a.134.134 0 01.06.105v8.33a.135.135 0 00.062.105l1.993 1.15c.033.02.06.004.06-.035v-10.77a.134.134 0 00-.06-.106l-5.025-2.903zm15.174 0c.033-.02.06-.004.06.035v2.302a.134.134 0 01-.06.105l-2.91 1.68a.134.134 0 00-.06.106v8.33a.135.135 0 01-.061.106l-1.993 1.15c-.034.02-.061.004-.061-.035v-10.77a.135.135 0 01.06-.106l5.025-2.903z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.98 7.503c0-.038-.027-.054-.06-.035l-7.86 4.546a.134.134 0 01-.12 0L8.08 7.468c-.034-.02-.061-.003-.061.035v2.302a.134.134 0 00.06.105l6.804 3.934a.135.135 0 01.06.105v14.285a.134.134 0 00.061.106l.935.54a.138.138 0 00.122 0l.935-.54a.134.134 0 00.06-.106V13.95a.135.135 0 01.061-.105L23.92 9.91a.134.134 0 00.06-.106v-2.3zm-7.944 5.816c-.008 0-.011-.006-.007-.013.004-.007.01-.007.014 0s0 .013-.007.013z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.012 7.202a.088.088 0 00-.069.084v2.873a.135.135 0 00.061.105l.935.54c.038.02.083.02.122 0l.935-.54a.135.135 0 00.06-.105V7.285a.087.087 0 00-.068-.084l-.92-.169a.456.456 0 00-.137 0l-.919.17z"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIop);
export default __webpack_public_path__ + "static/media/iop.955a5526cdba9be4b36a62bffbd2b000.svg";
export { ForwardRef as ReactComponent };